import React from 'react';
import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSliders, faChartLine, faPuzzlePiece, faLock } from '@fortawesome/free-solid-svg-icons';

const SectionContainer = styled.section`
  padding: 5rem 2rem;
  background: #f7fafc;
`;

const Content = styled.div`
  max-width: 1200px;
  margin: 0 auto;
`;

const Header = styled.div`
  text-align: center;
  margin-bottom: 4rem;
`;

const Title = styled.h2`
  font-size: clamp(2rem, 4vw, 3rem);
  color: #2d3748;
  margin-bottom: 1rem;
`;

const FeaturesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 2rem;
  margin-bottom: 3rem;
`;

const FeatureCard = styled.div`
  background: white;
  padding: 2rem;
  border-radius: 12px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  transition: transform 0.2s;

  &:hover {
    transform: translateY(-5px);
  }
`;

const IconContainer = styled.div`
  width: 50px;
  height: 50px;
  background: #ebf8ff;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 1.5rem;
  color: #3182ce;
  font-size: 1.5rem;
`;

const FeatureTitle = styled.h3`
  font-size: 1.25rem;
  color: #2d3748;
  margin-bottom: 1rem;
`;

const FeatureDescription = styled.p`
  color: #4a5568;
  line-height: 1.6;
`;

const CTAButton = styled.button`
  display: block;
  margin: 0 auto;
  padding: 1rem 2rem;
  font-size: 1.1rem;
  background: #4299e1;
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: transform 0.2s, background-color 0.2s;

  &:hover {
    background: #3182ce;
    transform: translateY(-2px);
  }
`;

const features = [
  {
    icon: faSliders,
    title: 'Customizable Matching',
    description: 'Tailor the wheel to match participants by preferences, roles, or interests.'
  },
  {
    icon: faChartLine,
    title: 'Analytics and Insights',
    description: 'Track engagement and measure networking success with real-time data.'
  },
  {
    icon: faPuzzlePiece,
    title: 'Seamless Integration',
    description: 'Integrate SpinToConnect into your virtual or hybrid events with ease.'
  },
  {
    icon: faLock,
    title: 'Private & Secure',
    description: 'Ensure participant privacy with our secure video calling platform.'
  }
];

export const FeaturesSection: React.FC = () => {
  return (
    <SectionContainer>
      <Content>
        <Header>
          <Title>Smart, Intuitive, and Built for Connection</Title>
        </Header>
        <FeaturesGrid>
          {features.map((feature, index) => (
            <FeatureCard key={index}>
              <IconContainer>
                <FontAwesomeIcon icon={feature.icon} />
              </IconContainer>
              <FeatureTitle>{feature.title}</FeatureTitle>
              <FeatureDescription>{feature.description}</FeatureDescription>
            </FeatureCard>
          ))}
        </FeaturesGrid>
        <CTAButton onClick={() => window.location.href = '/features'}>
          Discover All Features
        </CTAButton>
      </Content>
    </SectionContainer>
  );
}; 